import { blastApi } from "../../blastApi";
import { PlayerSchema } from "../types/Player";

export const getPlayersByTeamId = async ({ teamId }: { teamId: string }) => {
  const { data } = await blastApi.get<unknown>(`v2/teams/${teamId}/players`);
  return PlayerSchema.array().parse(data);
};
